import { apiPost } from "../ApiMethod";
import { setFirmwareData } from "../../mappers";

export const createAppRelease = async (data) => {
  const response = await apiPost("_appRelease", data);
  return { ...response, data: setFirmwareData(response.data) };
};
